/**
 * These are expected to match with the `name` attribute from the eatingStyles
 * query. The is used to find the id associated with a condition.
 */
export const VERY_PICKY = 'Very picky';
export const CAN_BE_PICKY = 'Can be picky';
